import * as types from "../types/deliveryInfo"

const initialState = {
  deliveryFee: 0,
  cinemaSolonNumber: "عطار",
  deliveryAddress: {},
  deliveryType: "dineIn",
  areaName: "",
  deliveryService: "internal",
  lalamoveQuotation: {
    quotationId: null,
    lalamoveDeliveryFee: 0
  }
}

const deliveryInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DELIVERY_AREA_NAME:
      return {
        ...state,
        deliveryService: "internal",
        areaName: action.areaName,
        deliveryFee: action.deliveryFee
      }
    case types.CHANGE_DELIVERY_ADDRESS:
      return {
        ...state,
        deliveryAddress: { ...action.deliveryAddress }
      }
    case types.CHANGE_DELIVERY_TYPE:
      return {
        ...state,
        deliveryType: action.deliveryType
      }
    case types.CHANGE_DELIVERY_SERVICE:
      return {
        ...state,
        deliveryService: action.deliveryService
      }
    case types.SET_SNAPBOX_DELIVERY_QUOTATION:
      return {
        ...state,
        lalamoveQuotation: { ...action.lalamoveQuotation }
      }
    case types.SET_CINEMA_SOLON:
      return {
        ...state,
        cinemaSolonNumber: action.cinemaSolonNumber
      }
    case types.CLEAR_DELIVERY_ADDRESS:
      return {
        deliveryFee: 0,
        deliveryAddress: {},
        deliveryType: state.deliveryType,
        deliveryService: "internal",
        lalamoveQuotation: {
          quotationId: null,
          lalamoveDeliveryFee: 0
        }
      }
    case types.CLEAR_DELIVERY_INFO:
      return { ...initialState }
    default:
      return state
  }
}

export default deliveryInfoReducer